import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import ChatsPage from './pages/ChatsPage';
import AdminPanel from './pages/AdminPanel';
import TermsAndConditions from './pages/TermsAndConditions';
import InitiativeCatalogPage from './pages/InitiativeCatalogPage';
import { FileErrorProvider } from './contexts/FileErrorContext';
import { UploadProgressProvider } from './contexts/UploadProgressContext';
import { RateLimitErrorProvider } from './contexts/RateLimitErrorContext';
import { SessionExpiredProvider } from './contexts/SessionExpiredContext';
import { ServerErrorProvider } from './contexts/ServerErrorContext';
import { SuccessProvider } from './contexts/SuccessContext';
import { TimeoutProvider } from './contexts/TimeoutContext';
import { SaveErrorProvider } from './contexts/SaveErrorContext';
import { interceptWordPressImages } from './utils/imageProxyInterceptor';

// Interceptar imágenes de WordPress al cargar la aplicación
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    interceptWordPressImages();
  });
} else {
  interceptWordPressImages();
}

// Manejador de errores global para capturar errores de scripts externos
window.addEventListener('error', (event) => {
  // Ignorar errores de scripts externos que no afectan la funcionalidad
  if (event.filename && (
    event.filename.includes('share-modal.js') ||
    event.filename.includes('chrome-extension') ||
    event.filename.includes('moz-extension') ||
    event.filename.includes('safari-extension')
  )) {
    event.preventDefault();
    return false;
  }
}, true);

// Manejador para errores no capturados en promesas
window.addEventListener('unhandledrejection', (event) => {
  // Ignorar errores de scripts externos
  if (event.reason && typeof event.reason === 'object' && event.reason.stack) {
    const stack = event.reason.stack.toString();
    if (stack.includes('share-modal.js') || 
        stack.includes('chrome-extension') ||
        stack.includes('moz-extension') ||
        stack.includes('safari-extension')) {
      event.preventDefault();
      return false;
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <FileErrorProvider>
      <UploadProgressProvider>
        <RateLimitErrorProvider>
          <SessionExpiredProvider>
            <ServerErrorProvider>
              <SuccessProvider>
                <TimeoutProvider>
                  <SaveErrorProvider>
                    <BrowserRouter>
                      <Routes>
                        <Route path="/" element={<App />} />
                        <Route path="/admin" element={<AdminPanel />} />
                        <Route path="/chats" element={<ChatsPage />} />
                        <Route path="/chats/:userId" element={<ChatsPage />} />
                        <Route path="/soporte" element={<ChatsPage />} />
                        <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />
                        <Route path="/catalogo-iniciativas" element={<InitiativeCatalogPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </BrowserRouter>
                  </SaveErrorProvider>
                </TimeoutProvider>
              </SuccessProvider>
            </ServerErrorProvider>
          </SessionExpiredProvider>
        </RateLimitErrorProvider>
      </UploadProgressProvider>
    </FileErrorProvider>
  </React.StrictMode>
);
